import React from "react";

export const layoutsFilled = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.288 2.307C16.591 2.25 15.725 2.25 14.633 2.25H9.367C8.275 2.25 7.409 2.25 6.712 2.307C5.998 2.365 5.395 2.487 4.844 2.767C3.94999 3.22267 3.22324 3.94977 2.768 4.844C2.487 5.394 2.365 5.998 2.307 6.712C2.261 7.272 2.252 7.942 2.25 8.75H21.75C21.748 7.942 21.739 7.273 21.693 6.712C21.635 5.998 21.513 5.395 21.233 4.844C20.7776 3.95014 20.0509 3.22341 19.157 2.768C18.605 2.487 18.002 2.365 17.288 2.307ZM21.693 17.288C21.75 16.591 21.75 15.725 21.75 14.633V10.25H9.75V21.75H14.633C15.725 21.75 16.591 21.75 17.288 21.693C18.002 21.635 18.605 21.513 19.157 21.233C20.0505 20.7774 20.7768 20.0507 21.232 19.157C21.513 18.605 21.635 18.002 21.693 17.288ZM4.844 21.232C5.394 21.513 5.998 21.635 6.712 21.693C7.152 21.729 7.66 21.743 8.25 21.747V10.25H2.25V14.633C2.25 15.725 2.25 16.591 2.307 17.288C2.365 18.002 2.487 18.605 2.767 19.157C3.22284 20.0506 3.94992 20.777 4.844 21.232Z"
        fill="currentColor"
      />
    </svg>
  );
};
